import { HttpParams } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Configurations } from '../../../Configuration';
import { LoginService } from '../service/login.service';
import { MessageService } from '../service/message.service';
import { AuthServiceBase } from './auth.service.base';
import { MenuService } from './menu.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService extends AuthServiceBase {

	endPoint: string;

	constructor(
		protected router: Router,
		private messageService: MessageService,
		protected loginService: LoginService,
		protected menuService: MenuService,
		protected translateService: TranslateService,
		@Optional() config?: Configurations
	) {
		super(router, menuService, loginService, translateService);

		this.endPoint = config.getLoginEndPoint() + 'session';
	}

	getAuthSession(pageAble: any, search?: string) {
		const url = this.endPoint + '/authSession';
		console.log(search);

		const params = new HttpParams()
			.set('page', pageAble.pageNumber)
			.set('size', pageAble.pageSize)
			.set('sortKeyword', pageAble.sortKeyword)
			.set('sortOrder', pageAble.sortOrder)
			.set('search', search);

		return this.messageService.query(url, params);
	}

}
